import React, { useState } from 'react';
import { ClassicHeaderContainer, StyledClassicLogo, ShareLinkContainer, ShareLinkIcon } from './ClassicHeader.styles';
import { Text } from '@components/typography';
import { CTALink } from '@components/CTALink';

import { classicHeaderData } from '@data-ts/shared/classic-header/classicHeader.data.ts';
// @ts-ignore
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getRootUrl } from '@utils/urlHelpers.util';

export const ClassicHeader: React.FC = () => {
  const [shareLinkText, setShareLinkText] = useState(classicHeaderData.shareLinkText);
  return (
    <ClassicHeaderContainer backgroundColor="yellow1" flexDirection={'row'}>
      <CTALink id="footer2brand" href={getRootUrl('/')} variant="altPurple">
        <StyledClassicLogo alt={classicHeaderData.joyLogoAltText} />
      </CTALink>
      <CopyToClipboard
        text={getRootUrl('/covid-wedding-calculator')}
        onCopy={() => setShareLinkText(classicHeaderData.shareLinkTextCopied)}
      >
        <ShareLinkContainer>
          <ShareLinkIcon name="share" color="purple6" />
          <Text variant="dek20" tagName="div">
            {shareLinkText}
          </Text>
        </ShareLinkContainer>
      </CopyToClipboard>
    </ClassicHeaderContainer>
  );
};
